import localStorageUtil from "@/utils/localStorageUtil";

const commonPlugin = {
    install(Vue, options) {
        Vue.prototype.$DataValid = function (payload) {
            return payload == null || payload.length == 0 ? false : payload
        }

        Vue.prototype.$movePrev = function () {
            this.$router.go(-1)
        }

        Vue.prototype.$moveLogin = function () {
            this.$router.push('/login')
        }

        Vue.prototype.$moveBrandSelect = function () {
            this.$router.push({name: 'BrandSelect'})
        }

        Vue.prototype.$moveMain = function () {
            this.$router.push('/home')
        }

        Vue.prototype.$moveIdpLogout = function () {
            const formElem = document.createElement("form");
            const signOutUrl = localStorageUtil.getIdpSignOutUrl();
            formElem.method = "POST";
            formElem.action = signOutUrl;
            document.body.appendChild(formElem);
            localStorageUtil.init();
            formElem.submit();
        }

        Vue.prototype.$customToolBar = [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ["link", "image"]
         ]
    }
}

export default commonPlugin
